import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPhone, FiMail, FiMapPin, FiClock, FiStar } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-red-800 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center">
                <span className="text-red-800 font-bold text-xl">S</span>
              </div>
              <span className="font-bold text-xl">Stars Event Decor</span>
            </div>
            <p className="text-red-100">
              Creating magical moments with professional event decoration services. 
              Transform your special occasions into unforgettable experiences.
            </p>
            <div className="flex items-center space-x-2">
              <SafeIcon icon={FiStar} className="w-5 h-5 text-yellow-400" />
              <span className="text-sm text-red-100">Premium Quality Decorations</span>
            </div>
          </div>

          <div className="space-y-4">
            <h3 className="font-semibold text-lg">Quick Links</h3>
            <nav className="space-y-2">
              <Link to="/" className="block text-red-100 hover:text-white transition-colors duration-200">
                Home
              </Link>
              <Link to="/services" className="block text-red-100 hover:text-white transition-colors duration-200">
                Services
              </Link>
              <Link to="/about" className="block text-red-100 hover:text-white transition-colors duration-200">
                About Us
              </Link>
              <Link to="/contact" className="block text-red-100 hover:text-white transition-colors duration-200">
                Contact Us
              </Link>
            </nav>
          </div>

          <div className="space-y-4">
            <h3 className="font-semibold text-lg">Services</h3>
            <div className="space-y-2 text-red-100">
              <p>Wedding Decorations</p>
              <p>Birthday Parties</p>
              <p>Corporate Events</p>
              <p>Anniversary Celebrations</p>
              <p>Baby Showers</p>
              <p>Holiday Decorations</p>
            </div>
          </div>

          <div className="space-y-4">
            <h3 className="font-semibold text-lg">Contact Info</h3>
            <div className="space-y-3">
              <a
                href="tel:+14163207474"
                className="flex items-center space-x-3 text-red-100 hover:text-white transition-colors duration-200"
              >
                <SafeIcon icon={FiPhone} className="w-5 h-5" />
                <span>+1 (416) 320-7474</span>
              </a>
              <a
                href="https://maps.app.goo.gl/PAVpvEhCYvxFP7aA"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-start space-x-3 text-red-100 hover:text-white transition-colors duration-200"
              >
                <SafeIcon icon={FiMapPin} className="w-5 h-5 mt-0.5" />
                <span>150 McLevin Ave #8<br />Scarborough, ON M1B 4Z7<br />Canada</span>
              </a>
              <div className="flex items-center space-x-3 text-red-100">
                <SafeIcon icon={FiClock} className="w-5 h-5" />
                <span>Available 24/7 for consultations</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-red-700 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-red-100 text-sm">
              © 2025 Stars Event Decor. All rights reserved.
            </p>
            <div className="text-red-100 text-sm">
              <span>Made with ❤️ for unforgettable celebrations</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;